import { motion } from 'framer-motion';
import { colors, spacing } from '@/theme';

export function SkeletonLoader() {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: `linear-gradient(180deg, ${colors.primary[50]} 0%, ${colors.gray[50]} 100%)`,
        display: 'flex',
        justifyContent: 'center',
        padding: spacing[3],
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 430,
          minHeight: 'calc(100vh - 1.5rem)',
          backgroundColor: colors.white,
          borderRadius: 28,
          border: `1px solid ${colors.gray[200]}`,
          boxShadow: '0 24px 60px rgba(15, 23, 42, 0.12)',
          overflow: 'hidden',
        }}
      >
        <motion.div initial={{ opacity: 0.5 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, repeat: Infinity, repeatType: 'reverse' }}>
          <div style={{ padding: `${spacing[5]} ${spacing[4]} ${spacing[3]}`, borderBottom: `1px solid ${colors.gray[100]}` }}>
            <div style={{ width: '55%', height: 24, backgroundColor: colors.gray[200], borderRadius: 8, marginBottom: spacing[2] }} />
            <div style={{ width: '85%', height: 14, backgroundColor: colors.gray[100], borderRadius: 6, marginBottom: spacing[3] }} />
            <div style={{ width: '100%', height: 8, backgroundColor: colors.gray[100], borderRadius: 999, marginBottom: spacing[3] }} />
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: spacing[2] }}>
              {[1, 2, 3, 4].map((i) => (
                <div key={i} style={{ height: 58, borderRadius: 12, backgroundColor: colors.gray[100] }} />
              ))}
            </div>
          </div>

          <div style={{ padding: `${spacing[4]} ${spacing[4]} ${spacing[8]}` }}>
            <div style={{ width: 52, height: 52, borderRadius: 18, backgroundColor: colors.gray[200], marginBottom: spacing[3] }} />
            <div style={{ width: '70%', height: 24, backgroundColor: colors.gray[200], borderRadius: 8, marginBottom: spacing[2] }} />
            <div style={{ width: '100%', height: 14, backgroundColor: colors.gray[100], borderRadius: 6, marginBottom: spacing[3] }} />
            <div style={{ width: '100%', height: 8, backgroundColor: colors.gray[100], borderRadius: 999, marginBottom: spacing[6] }} />

            {[1, 2, 3].map((i) => (
              <div key={i} style={{ marginBottom: spacing[4], padding: spacing[4], border: `1px solid ${colors.gray[100]}`, borderRadius: 16 }}>
                <div style={{ width: '60%', height: 16, backgroundColor: colors.gray[200], borderRadius: 6, marginBottom: spacing[2] }} />
                <div style={{ width: '90%', height: 12, backgroundColor: colors.gray[100], borderRadius: 6, marginBottom: spacing[3] }} />
                <div style={{ width: '100%', height: 44, backgroundColor: colors.gray[100], borderRadius: 12 }} />
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
